import { Link } from "react-router-dom";
import { CircleDot, Flag } from "lucide-react";
import { useT } from "@/lib/i18n";
import { TYRES, formatDate } from "@/lib/format";

export const TyreSetCard = ({ set, highlight, showEvent, index = 0 }) => {
  const { t, lang } = useT();
  const to = `/tyres/${set.id}${highlight ? `?barcode=${encodeURIComponent(highlight)}` : ""}`;
  return (
    <Link to={to} data-testid={`tyreset-card-${set.id}`} style={{ animationDelay: `${Math.min(index, 10) * 40}ms` }}
      className="fade-up group block bg-[#12141C] border border-[#282D3D] rounded-sm p-4 hover:border-[#FFB800]/60 hover:bg-[#181B26] transition-colors duration-200">
      {showEvent && (
        <div data-testid="tyreset-card-event" className="-mx-4 -mt-4 mb-3 px-4 py-2 border-b border-[#282D3D] bg-[#090A0F] flex items-start gap-2 rounded-t-sm">
          <Flag className="w-4 h-4 text-[#FF3B30] mt-0.5 shrink-0" />
          <div className="min-w-0">
            <div className="font-heading font-bold uppercase tracking-wide text-base leading-tight text-white break-words">{set.event_name || "—"}</div>
            <div className="font-mono text-[11px] text-slate-400">{formatDate(set.event_date, lang)}{set.event_track ? ` · ${set.event_track}` : ""}</div>
          </div>
        </div>
      )}
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <CircleDot className="w-4 h-4 text-[#FFB800]" />
            <h3 data-testid="tyreset-card-name" className="font-heading font-bold uppercase text-xl truncate">{set.name}</h3>
          </div>
          {(set.brand || set.model) && (
            <div data-testid="tyreset-card-model" className="mt-1.5 inline-flex items-center gap-1.5 max-w-full px-2 py-0.5 rounded-sm border border-[#FFB800]/40 bg-[#FFB800]/10 font-mono text-[11px] uppercase tracking-wide text-[#FFB800]">
              <span className="truncate">{[set.brand, set.model].filter(Boolean).join(" · ")}</span>
            </div>
          )}
        </div>
        <div className="text-right shrink-0">
          <div data-testid="tyreset-card-laps" className="font-mono font-bold text-2xl text-white leading-none">{set.total_laps}</div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mt-1">{t("laps_short")} · {set.usage_count} {t("sessions_count")}</div>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-1.5 mt-3">
        {TYRES.map((p) => {
          const code = set.tyres?.[p]?.barcode;
          const hit = highlight && code === highlight;
          return (
            <div key={p} className={`border rounded-sm px-2 py-1 font-mono text-[11px] truncate ${hit ? "border-[#FFB800] bg-[#FFB800]/10 text-[#FFB800]" : "border-[#282D3D] bg-[#090A0F] text-slate-300"}`}>
              <span className="text-slate-500 text-[9px] uppercase mr-1">{t(`tyre_${p}`)}</span>{code || "—"}
            </div>
          );
        })}
      </div>
    </Link>
  );
};
